<lib-form-field-container
    #anchor
    [isOptional]="isOptional"
    [kind]="FormContainerKind.SubForm">

    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-content prefixText select="[prefixText]"></ng-content>
    <ng-content suffixText select="[suffixText]"></ng-content>

    <ng-container readOnly>
        <div class="wrapper-content" #providedReadOnly>
            <ng-content select="[readOnly]" ></ng-content>
        </div>
        <div class="default-content">
            @if (formControl.value) {
                @if (showHoursField) {
                    {{ formControl.value | formatSeconds:'HH:MM:SS'}}
                } @else {
                    {{ formControl.value | formatSeconds:'MM:SS'}}
                }
            } @else {
                <ng-container i18n="@@CommonNotSpecifiedLabel">
                    Not specified
                </ng-container>
            }
        </div>
    </ng-container>

    <!-- <lib-button menu *ngIf="isOptional && !isReadOnly"
        [disabled]="isDisabled"
        [kind]="ButtonKind.Link">
        <ng-container label i18n="@@FormFieldClearLabel">Clear</ng-container>
    </lib-button> -->

    <form  [formGroup]="form">
        <div class="d-flex w-100 gap-2 sb-form-field-full" tabindex="-1" (focusout)="FocusOut()">
            @if (showHoursField) {
                <lib-input-number class="w-100"
                    [hideErrors]="true"
                    [isOptional]="false"
                    [formControl]="form.controls.Hours"
                    (change)="HoursChanged($event)" [qaTag]="qaTag+'-hours'">
                    <ng-container suffixText i18n="@@CommonHoursLowerCase">hours</ng-container>
                </lib-input-number>
            }
            <lib-input-number class="w-100" [hideErrors]="true"
                [formControl]="form.controls.Minutes"
                [isOptional]="false"
                (change)="MinutesChanged($event)"
                [qaTag]="qaTag+'-minutes'">
                <ng-container suffixText i18n="@@CommonMinutesLowerCase">minutes</ng-container>
            </lib-input-number>
            @if (showSecondsField) {
                <lib-input-number class="w-100"
                    [hideErrors]="true"
                    [formControl]="form.controls.Seconds"
                    [isOptional]="false" (change)="SecondsChanged($event)" [qaTag]="qaTag+'-seconds'">
                    <ng-container suffixText i18n="@@CommonSecondsLowerCase">seconds</ng-container>
                </lib-input-number>
            }
        </div>
    </form>

</lib-form-field-container>